<div fxLayout="column" class="faq" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="100" class="container">
    <h2>Frequently asked questions</h2>
    <p>If you have any other questions, feel free to reach out to our support team!</p>
    <mat-accordion>
      @for (faq of faqs; track faq; let i = $index) {
        <mat-expansion-panel [expanded]="i === 0">
          <mat-expansion-panel-header>
            <mat-panel-title fxLayout="row" fxLayoutAlign="space-between center">
              {{ faq.question }}
              <mat-icon [svgIcon]="false ? 'ss3-minus-circle' : 'ss3-plus-circle'" />
            </mat-panel-title>
          </mat-expansion-panel-header>

          <p [innerHTML]="faq.answer"></p>
          <div fxLayout="column" fxLayoutAlign="start start">
            <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="link" (click)="goToPrimary(sectionType)">
              <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
              <mat-icon svgIcon="ss3-arrow-right-blue" />
            </button>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
      <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
        <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
